import { environment } from 'src/environments/environment';

const MCP_CALLBACK_URL = 'https://mcp.sytex.io/oauth/callback';
const EUROPE_MCP_CALLBACK_URL = 'https://mcp.eu.sytex.io/oauth/callback';

/** The part of the deployment's environment the /cli page's region rules read. */
export interface DeploymentSettings {
  name: string;
  cognito: { region: string };
  mcp_callback_url?: string;
}

/**
 * Where the MCP mode of the /cli page sends the user back: the OAuth callback
 * of the Sytex MCP server that serves this deployment's region. It comes from
 * configuration and never from the page's link, so the page cannot be made to
 * hand a code to anyone else.
 *
 * Production knows its own (Europe or not, by the user pool's region). Any
 * deployment may name one in the environment's `mcp_callback_url`, which wins;
 * without either, there is no MCP server to return to and this is null.
 */
export function mcpCallbackUrl(settings: DeploymentSettings = environment): string | null {
  const configuredUrl = settings.mcp_callback_url;
  if (configuredUrl) {
    return configuredUrl;
  }

  const isProduction = settings.name === 'production';
  if (!isProduction) {
    return null;
  }
  const isEuropeDeployment = settings.cognito.region.startsWith('eu-');
  return isEuropeDeployment ? EUROPE_MCP_CALLBACK_URL : MCP_CALLBACK_URL;
}
